module.exports = __webpack_public_path__ + "static/media/chess.cd3f2445.svg";